"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SportActivityAdapter {
    constructor() {
        this.adaptSportActivity = (sportActivities, date /* YYYY-MM-DD */) => {
            return [
                {
                    date,
                    sportActivities: sportActivities.map(this.apiItemToItem),
                },
            ];
        };
        this.extractDateFromSportActivityApiItem = (sportActivity) => sportActivity.occurredAt.iso8601.split("T")[0];
        this.processExertion = (percent) => {
            if (percent > 0 && percent <= 5)
                return 0.5;
            return Math.round(percent / 10);
        };
        this.apiItemToItem = (sportActivity) => {
            var _a;
            return {
                id: sportActivity.id,
                date: this.extractDateFromSportActivityApiItem(sportActivity),
                duration: sportActivity.duration.minutesInTotal,
                note: sportActivity.note,
                exertion: this.processExertion((_a = sportActivity.exertion) === null || _a === void 0 ? void 0 : _a.percentage) || null,
                type: {
                    name: sportActivity.type.name,
                    isCustom: sportActivity.type.isCustom,
                    iconUrl: sportActivity.type.icon.url,
                },
            };
        };
    }
}
exports.default = SportActivityAdapter;
//# sourceMappingURL=SportActivityAdapter.js.map